export default {
  generic: "Algo ha salido mal. Inténtelo de nuevo.",
  serverError: "Se ha producido un error del servidor. Inténtelo de nuevo.",
  network: "Error de red. Compruebe la conexión e inténtelo de nuevo.",
  validation: "Revise los valores enviados e inténtelo de nuevo.",
  loginFailed: "Error al iniciar sesión",
  createActivity: "Error al crear la actividad",
  updateActivity: "Error al actualizar la actividad",
  activityActivationIncomplete:
    "Aún no puede activar esta actividad. Falta: {{items}}.",
  activityActivationMissingDescription: "descripción en todos los idiomas",
  activityActivationMissingPhotos: "al menos una foto",
  activityActivationMissingMenuItems: "platos del menú",
  activityActivationMissingPricedItems:
    "al menos un artículo con precio mayor que cero",
  activityActivationMissingAvailability:
    "al menos una franja de disponibilidad",
  updateServiceCategories: "Error al actualizar las categorías de servicio",
  changeProfileType: "No se pudo cambiar el tipo de perfil",
  saveProfile: "Error al guardar el perfil",
  loadDevicePresets: "No se pudieron cargar los ajustes del dispositivo",
  savePreset: "No se pudo guardar el ajuste",
  deletePreset: "No se pudo eliminar el ajuste",
  createDevice: "No se pudo crear el dispositivo",
  deviceDuplicateSerialNumber:
    "Ya existe un dispositivo con ese número de serie",
  deviceDuplicateSoftwareId:
    "La clave de software ya está asignada al dispositivo con serie {{serialNumber}}",
  deviceDuplicateSoftwareIdUnknown:
    "La clave de software ya está asignada a otro dispositivo",
  loadDevices: "No se pudieron cargar los dispositivos",
  loadReaders: "No se pudieron cargar los lectores",
  loadReaderPresets: "No se pudieron cargar los ajustes del lector",
  updateDevice: "No se pudo actualizar el dispositivo",
  regenerateCredentials: "No se pudieron regenerar las credenciales",
  assignDevice: "No se pudo asignar el dispositivo",
  updateHouse: "No se pudo actualizar la estructura",
  renameDevice: "No se pudo renombrar el dispositivo",
  reorderDevices: "No se pudieron reordenar los dispositivos",
  loadHouses: "No se pudieron cargar las estructuras",
  loadHosts: "No se pudieron cargar los hosts",
  loadSalesAgents: "No se pudieron cargar los agentes comerciales",
  loadOwners: "No se pudieron cargar los vendedores y anfitriones",
  loadSellers: "No se pudieron cargar los vendedores",
  loadActivities: "No se pudieron cargar las actividades",
  loadRegions: "No se pudieron cargar las regiones",
  createHouse: "No se pudo crear la estructura",
  createHost: "No se pudo crear el anfitrión",
  readerOperation: "La operación del lector ha fallado",
  addPresence: "No se pudo registrar al huésped",
  updatePresence: "No se pudo actualizar al huésped",
  deletePresence: "No se pudo eliminar al huésped",
  createSalesAgent: "No se pudo crear el agente de ventas",
  autoTranslateItem:
    "La traducción automática ha fallado. Inténtelo de nuevo más tarde.",
  forgotPasswordFailed:
    "No se pudo enviar el correo de restablecimiento. Inténtelo más tarde.",
  setPasswordFailed:
    "No se pudo establecer la contraseña. Inténtelo de nuevo o solicite un nuevo enlace.",
  amendReasonWrongStatus:
    "Esta reserva no se puede modificar en su estado actual.",
  amendReasonRefunded: "Esta reserva fue reembolsada y no se puede modificar.",
  amendReasonRefundRetrying: "Hay un reembolso en curso; inténtelo más tarde.",
  amendReasonProviderBlocksAmendment:
    "Esta reserva está sincronizada externamente y no se puede modificar aquí.",
  amendReasonMissingVisit: "Esta reserva no tiene fecha/hora para modificar.",
  amendRequiresOverride:
    "Las restricciones de capacidad o plazo requieren una anulación explícita.",
  impersonateUser: "No se pudo suplantar a este usuario.",
} as const;
